<template>
    <div v-if="ready" class="col-12 py-2 results-heading d-flex justify-content-between">
        <div class="count-wrap">
            <h4>Search Results</h4>
            <div class="counts">
                Showing {{ min_count }} - {{ count }} of {{ total_count }}
            </div>
        </div>
        <div class="download-buttons-wrap">
            <span>Export as:</span>
            <button type="button" @click.prevent="generateCSV()" class="btn btn-primary mx-1">CSV</button>
            <button type="button" @click.prevent="generatePDF()" class="btn btn-dark">PDF</button>
        </div>
    </div>
    <div v-else class="col-12 py-2 d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import HTML2PDF from 'html2pdf.js'

export default {
    props: ['posts', 'ready'],
    data() {
        return {

        }
    },
    computed: {
        min_count() {
            return this.$store.state.results_count == 0 ? 0 : 1;
        },
        count() {
            return Math.min(this.$store.state.shown_count, this.$store.state.results_count)
        },
        total_count(){
            return this.$store.state.results_count
        }
    },
    methods: {
        generateCSV(){
            //let csvOut = Object.keys(this.$props.posts).map(key => [key, this.$props.posts[key]])
            var csv = 'Title,Cancer Types,Therapy Lines,Description,Link,Protocol,Site Activity Name,Locations\n'

            let csvOut = JSON.parse(JSON.stringify(this.$props.posts))

            //console.log(csvOut)

            let csvData = []
            for(var post in csvOut){
                csvData.push([post, csvOut[post]])
            }

            //merge the data with CSV
            csvData.forEach(function(row) {
                row.forEach(function(i) {
                    if(typeof(i) !== 'string'){
                        addToCSV(i.title)
                        if(i.cancer_types.length > 0){
                            addToCSV(i.cancer_types.toString().trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, '/ '))
                        } else {
                            addToCSV('')
                        }
                        if(i.therapy_lines.length > 0){
                            addToCSV(i.therapy_lines.toString().trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, '/ '))
                        } else {
                            addToCSV('')
                        }
                        addToCSV(i.excerpt.trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, ' '))
                        addToCSV(i.trial_link.trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, ' '))
                        addToCSV(i.protocol.trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, ' '))
                        addToCSV(i.site_activity_name.trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, ' '))
                        if(i.location_ids.length > 0){
                            addToCSV(i.location_ids.toString().trim().replace(/(\r\n|\n|\r)/gm, "").replace(/,/g, '/ ').replace('"', ''))
                        } else {
                            addToCSV('')
                        }
                    }
                })
                csv += "\n";
            });
        
            function addToCSV(x){
                csv += x
                csv += ','
            }

            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            
            //provide the name for the CSV file to be downloaded
            hiddenElement.download = 'Clinical_Trials.csv';
            hiddenElement.click();
        },
        generatePDF(){

            console.log('Generating PDF...');
            let cards = document.querySelectorAll('#clinical-trials-results .card-wrap');
            let max_results = 200;
            // This limit is necessary because of a limitation in the max size of html5 canvas which, if exceeded, results in blank PDF output.
            if (cards.length > max_results) {
                alert('Please use the filters above to reduce the number of results below ' + max_results + ' before exporting as PDF.');
                return;
            }
            let pdfElem = document.createElement('div');
            pdfElem.id = "pdf-wrapper";
            let body = document.querySelector('body');
            let logodiv = document.createElement('div');
            logodiv.id = "pdf-logo";
            let logo = document.createElement('img');
            logo.setAttribute('src', '/wp-content/themes/wakefly/static/fcs_logo_for_pdf.png');
            logo.setAttribute('height', '100px');
            logodiv.appendChild(logo);
            pdfElem.appendChild(logodiv);
            body.appendChild(pdfElem);
            let card_count = 0;
            [...cards].forEach((card) => {
                let pdf_card = card.cloneNode(true);
                let pdf_processed = pdf_card.querySelector('.card-body');
                pdfElem.appendChild(pdf_processed);
            });

            let PDF = document.getElementById('pdf-wrapper')
            this.html2PDF(PDF).then((status) => {
                if(status == 'true'){
                    PDF.parentNode.removeChild(PDF);
                }
            });
        },
        html2PDF(pdf){
            return new Promise((resolve, reject) => {
                if(pdf){
                    var opt = {
                        margin:       [0.75, 0.4],
                        pagebreak:    {mode: ['avoid-all']},
                        filename:     'ClinicalTrials.pdf',
                        image:        { type: 'png' },
                        html2canvas:  { scale: 1, dpi: 192, letterRendering: false },
                        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
                    };
                    HTML2PDF().set(opt).from(pdf).save();         
                    resolve('true')
                }
            })
        }
    }
}
</script>
